import { Injectable } from '@angular/core';
import { Router, UrlTree, NavigationExtras } from '@angular/router';
import { PermissionService } from 'src/app/services/permission.service';
import { ObserverService } from 'src/app/services/observer.service';

@Injectable()
export class StartPageGuard {

    constructor(
        private router: Router,
        private permissionService: PermissionService,
        private observerService: ObserverService,
    ) {}

    async canActivate(): Promise<UrlTree> {

        await this.permissionService.loadCache();

        if(this.permissionService.isPermitted('pos-sell')) {
            return this.router.createUrlTree(['/secure/sell']);
        }
        else if(this.permissionService.isPermitted('pos-parked-carts-view-parked-cart')) {
            return this.router.createUrlTree(['/secure/parked-carts']);
        }
        else if(this.permissionService.isPermitted('pos-quotes-view-quote')) {
            return this.router.createUrlTree(['/secure/quotes']);
        }
        else if(this.permissionService.isPermitted('pos-orders-view-order')) {
            return this.router.createUrlTree(['/secure/orders']);
        }
        else if(this.permissionService.isPermitted('pos-people-view-person')) {
            return this.router.createUrlTree(['/secure/people']);
        }
        else if(this.permissionService.isPermitted('pos-organisations-view-organisation')) {
            return this.router.createUrlTree(['/secure/organisations']);
        }
        else if(this.permissionService.isPermitted('pos-reports')) {
            return this.router.createUrlTree(['/secure/reports']);
        }
        else if(this.permissionService.isPermitted('pos-cash-tracking')) {
            return this.router.createUrlTree(['/secure/cash-tracking']);
        }
        else if(this.permissionService.isPermitted('pos-settings')) {
            return this.router.createUrlTree(['/secure/settings']);
        }
        else {
            return this.router.createUrlTree(['/secure/no-permissions']);
        }

    }

    async navigateToStartPage(options?: NavigationExtras, waitForDataLoad: boolean = false): Promise<void> {

        if(waitForDataLoad) {

            // Wait for loadData() to complete — by then users have updated and refreshed the permission cache with fresh data.
            await new Promise<void>((resolve) => {
                const sub = this.observerService.subscribe('load_data_completed|start_page_guard', () => {
                    sub.unsubscribe();
                    resolve();
                });
            });

            // users_changed fires during loadData() and kicks off a cache reload; await it so isPermitted() sees the fresh data.
            await this.permissionService.loadCache();
            
        }
        else {
            await this.permissionService.loadCache();
        }

        let path: string;

        if (this.permissionService.isPermitted('pos-sell')) {
            path = '/secure/sell';
        }
        else if (this.permissionService.isPermitted('pos-parked-carts-view-parked-cart')) {
            path = '/secure/parked-carts';
        }
        else if (this.permissionService.isPermitted('pos-quotes-view-quote')) {
            path = '/secure/quotes';
        }
        else if (this.permissionService.isPermitted('pos-orders-view-order')) {
            path = '/secure/orders';
        }
        else if (this.permissionService.isPermitted('pos-people-view-person')) {
            path = '/secure/people';
        }
        else if (this.permissionService.isPermitted('pos-organisations-view-organisation')) {
            path = '/secure/organisations';
        }
        else if (this.permissionService.isPermitted('pos-reports')) {
            path = '/secure/reports';
        }
        else if (this.permissionService.isPermitted('pos-cash-tracking')) {
            path = '/secure/cash-tracking';
        }
        else if (this.permissionService.isPermitted('pos-settings')) {
            path = '/secure/settings';
        }
        else {
            path = '/secure/no-permissions';
        }

        this.router.navigateByUrl(path, options);

    }

}
